import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { Organization } from '../../../types/organization';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { mutationKeys } from '../mutationKeys';

export const updateOrganization = async (formData: Organization) => {
  const response = await CustomAxios.put(`organizations`, { organization: formData });
  const { data } = response;
  return data;
};

interface UseUpdateOrganizationFormProps {
  onSuccessCallback: () => void;
}
export function useUpdateCurrentOrganization({ onSuccessCallback }: UseUpdateOrganizationFormProps) {
  return useMutation({
    mutationKey: [mutationKeys.updateOrganization],
    mutationFn: (formData: Organization) => updateOrganization(formData),
    onSuccess: (data: Organization) => {
      queryClient.setQueryData([queryKeys.currentOrganization], data);
      queryClient.invalidateQueries({ queryKey: [queryKeys.currentOrganization] });
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status !== 400) return;
      const data = err.response?.data;
      if (data && typeof data === 'object' && 'uuid' in data) {
        queryClient.setQueryData([queryKeys.currentOrganization], data as Organization);
      }
    },
  });
}
